// extracted by mini-css-extract-plugin
module.exports = {"row":"NewCategory_row__TjXsV","col":"NewCategory_col__C1jz7","card":"NewCategory_card__3W_tq"};